import type { ReactNode } from "react";

export const cleanReactChildren = (children: ReactNode) =>
  ([] as ReactNode[])
    .concat(children)
    .filter(
      child =>
        child !== null && child !== undefined && typeof child !== "boolean"
    );
